<script>
export default {
    props: {
        id: {
            type: Number,
            required: true
        }
    },
    data: () => ({
        selected: false,
        parent: undefined
    }),
    mounted() {
        this.parent = this.$el.parentElement.parentElement.parentElement;
        this.$eventsBus.$on('marker-over', this.handleMarkerOver);
        this.$eventsBus.$on('marker-out', this.handleMarkerOut);
        // this.$eventsBus.$on('marker-click', this.handleMarkerClick);
    },
    beforeDestroy() {
        this.$eventsBus.$off('marker-over', this.handleMarkerOver);
        this.$eventsBus.$off('marker-out', this.handleMarkerOut);
        // this.$eventsBus.$off('marker-click', this.handleMarkerClick);
    },
    methods: {
        handleMarkerOver(id) {
            if (id === `marker_${this.id}`) {
                this.selected = true;
                $(this.parent).animate({
                    scrollTop: this.$el.offsetTop - 20
                }, 300);
            }
        },
        handleMarkerOut(id) {
            if (id === `marker_${this.id}`) {
                this.selected = false;
            }
        },
        handleCardOver(id) {
            this.$eventsBus.$emit('community-card-over', id);
        },
        handleCardOut(id) {
            this.$eventsBus.$emit('community-card-out', id);
        }
    }
};
</script>
